import { Component, OnInit } from '@angular/core';
import { User } from 'src/app/model/user.model';
import { Role } from 'src/app/model/role.model';
import { AuthService } from 'src/app/service/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  currentUser: User;
  constructor(
    private authService: AuthService,
    private router: Router) { 
    this.authService.currentUser.subscribe(x=>this.currentUser=x);
  }

  ngOnInit() {
  }

  goToCreateReservation(){
    this.router.navigateByUrl('/reservation-add');
  }

  goToProfil(){
    this.router.navigateByUrl('/profile');
  }

  goToResrvationList(){
    this.router.navigateByUrl('/reservation-list');
  }

  goToInstructorList(){
    this.router.navigateByUrl('/instructor-list');
  }

  goToSchedule(){
    this.router.navigateByUrl(`/schedule-instructor/${this.currentUser.id}`);
  }

  get isAdmin() {
    return this.currentUser && this.currentUser.role === Role.Admin;
}

  get isUser() {
    return this.currentUser && this.currentUser.role === Role.User;
  }

  get isInstructor() {
    return this.currentUser && this.currentUser.role === Role.Instructor;
  }
}
